import React from 'react'
import { useTranslation } from 'react-i18next'
import { Divider, Header } from 'semantic-ui-react'
import DateFields from './DateFields'

const FeedingFields: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <Header as='h4'>{t('Feeding Period')}</Header>
      <Divider />

      <p style={{ color: '#666', marginBottom: '1em' }}>
        {t('Please indicate the period and how many animals the order is/was fed (on average).')}
      </p>

      <DateFields />
    </>
  )
}

export default FeedingFields
